<template>
    <div>
        <div class="mb-1">
            <label class="form-label">Link</label>
        </div>

        <div class="mb-1 d-flex align-items-center">
<!--            <div class="mx-2">Color</div>-->
<!--            <color-picker :color-object="link" color-field="color" class="mt-1"></color-picker>-->

            <input type="checkbox" id="underlineCheckbox" v-model="link.underline" class="ms-4 form-check-input">
            <label for="underlineCheckbox" class="ms-2">Underline</label>
        </div>

    </div>
</template>

<script>
import ColorPicker from "../components/ColorPicker.vue";
export default {
    name: 'LinkStyleEditor',
    components: {ColorPicker},
    props: ['link'],
    data () {
        return {
            model: webase.model
        }
    }
}
</script>

<style>

</style>
